import { timeToSeconds } from "utils";
import anchorCatch from "anchor-catch";

// Enable transcript time-links.
// https://pistacja.tv/link/to/player/video#seek?time=00:00:54

export default function Transcript(id, playerId) {
  const player = document.querySelector(playerId);
  const transcriptContainer = document.querySelector(id);
  const IS_VALID_SETUP =
    transcriptContainer instanceof HTMLElement && player instanceof HTMLElement;

  if (IS_VALID_SETUP) {
    const domain = "https://www.youtube.com";
    const videoTranscript = anchorCatch(transcriptContainer);

    // Catch click event on a subtitle link.
    videoTranscript.catch("seek", (options) => {
      player.contentWindow.postMessage(
        JSON.stringify({
          func: "seekTo",
          event: "command",
          args: [timeToSeconds(options.time), true],
        }),
        domain
      );

      player.contentWindow.postMessage(
        JSON.stringify({
          func: "playVideo",
          event: "command",
        }),
        domain
      );
    });
  }
}
